import { useQuery } from '@tanstack/react-query'
import { API_URL } from '../const'
import { Regione } from '../types'
import axios from 'axios'
import { serializeQueryParams } from './utils'

export async function getRegioni(
  geocontext: number | undefined,
  params: Record<string, any> = {},
  signal?: AbortSignal
) {
  return (
    await axios.get(`${API_URL}/geo-contexts/${geocontext}/regions/`, {
      signal,
      params: serializeQueryParams(params),
    })
  ).data as Regione[]
}

export function useRegioni(
  geocontext: number | undefined,
  params: Record<string, any> = {}
) {
  return useQuery({
    queryKey: ['regioni', geocontext, params],
    queryFn: ({ signal }) => getRegioni(geocontext!, params, signal),
    keepPreviousData: true,
    suspense: false,
    enabled: !!geocontext && (!!params.q || !!params.id),
  })
}

export function useRegioneById(
  geocontext: number | undefined,
  id: number | undefined
) {
  return useQuery({
    queryKey: ['regione', geocontext, id],
    queryFn: ({ signal }) =>
      getRegioni(geocontext!, { id }, signal).then((regioni) => regioni[0]),
    keepPreviousData: true,
    suspense: false,
    enabled: !!geocontext && !!id,
  })
}